import SavingsData from "./data"

export default function savingsDataFromJson(json) {
    return new SavingsData(
        json.fuelECA,
        json.fuelNonECA,
        json.fuelOverall,
        json.time,
        json.tce
    )
}